<div class="__container drag-boundary-container" *ngrxLet="clusterEnabled$; let clusterEnabled" #dragBoundaryContainerRef>
  @let uiSettings = bookOfBusinessUISettings();
  @if (uiSettings.opened) {
    <div
      class="position-absolute rmv-drag-z-index"
      cdkDrag
      [cdkDragFreeDragPosition]="{
        x: uiSettings.position.x,
        y: uiSettings.position.y
      }"
      cdkDragBoundary=".drag-boundary-container"
      (cdkDragEnded)="onBookOfBusinessPositionChange($event, dragBoundaryContainerRef)"
    >
      @let categoryChartParams = bookOfBusinessParams$ | async;
      <app-book-of-business
        [params]="categoryChartParams || undefined"
        [collapsed]="uiSettings.collapsed"
        [selectedTab]="uiSettings.selectedTab"
        [inPercent]="uiSettings.inPercent"
        (closeEvent)="bookOfBusinessOpened.set(false)"
        (collapsedChange)="onBookOfBusinessCollapseChange($event)"
        (selectedTabChange)="onBookOfBusinessSelectedTabChange($event)"
        (inPercentChange)="onBookOfBusinessInPercentChange($event)"
      ></app-book-of-business>
    </div>
  }
  <google-map
    height="100%"
    width="100%"
    [zoom]="zoom"
    [center]="center"
    [options]="options"
    (mapInitialized)="onMapInit($event)"
    (boundsChanged)="onBoundsChanged()"
    *ngIf="center"
  >
    <ng-container *ngIf="markersAndClusters$ | async as markersAndClusters">
      <ng-container *ngIf="$any(markersAndClusters).clusterMarkers as clusterMarkers">
        <map-marker
          [position]="marker.position"
          [options]="marker.options"
          (mapClick)="onClusterClick(marker.cluster)"
          *ngFor="let marker of clusterMarkers; trackBy: trackByFn"
        ></map-marker>
      </ng-container>
      <map-marker
        [position]="marker.position"
        [title]="marker.title"
        [options]="marker.options"
        (mapClick)="openInfoWindow(markerRef, marker.info)"
        #markerRef="mapMarker"
        *ngFor="let marker of markersAndClusters.markers; trackBy: trackMarkerByFn"
      ></map-marker>
    </ng-container>

    <map-marker
      *ngIf="gpsLocationMarker"
      [position]="gpsLocationMarker.position"
      [options]="gpsLocationMarker.options"
    >
    </map-marker>

    <map-marker
      *ngIf="userLocationMarker"
      [position]="userLocationMarker.position"
      [options]="userLocationMarker.options"
    >
    </map-marker>

    <map-info-window [options]="{ headerDisabled: true }" #infoWindow="mapInfoWindow">
      @if (infoWindowContent) {
        @let slaRange = slaRange$ | async;
        @if (slaRange) {
          <app-location-info-window-content
            [account]="infoWindowContent"
            [groupAccounts]="infoWindowItems"
            [slaRange]="slaRange"
            [dealsFilterGroups]="dealsFilterGroupsParams()"
            (assignedToMe)="onAssignedToMe()"
            (closeEvent)="infoWindow.close()"
          ></app-location-info-window-content>
        }
      }
    </map-info-window>
  </google-map>

  <div
    class="__left-center-panel d-flex flex-column justify-content-center gap-3"
    *ngIf="isDrawingActive()"
  >
    <app-bulk-operations-map-menu
      [selected]="computedSelectedAccounts() || []"
      [loading]="selectedAccountsLoading()"
      (clear)="onSelectedClear()"
    ></app-bulk-operations-map-menu>
  </div>

  <div class="__right-panel d-flex flex-column gap-3">
    <app-button
      class="--primary --stroke --large --location"
      icon="rmv-icon-refresh"
      (click)="refresh()"
      [loading]="!!(loading$ | async)"
    ></app-button>
    <app-button
      class="--primary --stroke --large --location"
      svgIcon="/assets/images/ic-position.svg"
      (click)="getMyGPSLocation()"
      [loading]="detectingGpsLocation"
    ></app-button>
  </div>

  <div class="__drawing-manager d-flex justify-content-start">
    <button
      class="__drawing-manager-button"
      [ngClass]="{ '--selected': isDrawingActive() }"
      (click)="switchDrawingMode()"
    >
      <span class="__drawing-manager-button-icon rmv-icon-pencil"></span>
      <span class="__drawing-manager-button-title">Actions</span>
    </button>
    <button
      class="__drawing-manager-button"
      [ngClass]="{ '--selected': clusterEnabled }"
      (click)="switchCluster()"
    >
      <span class="__drawing-manager-button-icon rmv-icon-switch-cluster"></span>
      <span class="__drawing-manager-button-title">Cluster</span>
    </button>
    <button
      class="__drawing-manager-button"
      [ngClass]="{ '--selected': !!(categoryColorInMarkersEnabled$ | async) }"
      (click)="switchCategoryColorInMarkers()"
    >
      <span class="__drawing-manager-button-icon rmv-icon-pin"></span>
      <span class="__drawing-manager-button-title">Color</span>
    </button>
    <button
      class="__drawing-manager-button"
      [ngClass]="{ '--selected': !!(slaColorInMarkersEnabled$ | async) }"
      (click)="switchSLAColorInMarkers()"
    >
      <span class="__drawing-manager-button-icon rmv-icon-sla"></span>
      <span class="__drawing-manager-button-title">Coverage</span>
    </button>
  </div>
</div>
<app-no-permissions *ngxPermissionsOnly="['MOBILE_USER']"></app-no-permissions>
